import {
  Dialog, DialogContent, DialogHeader, DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

// Dialog used by WorkOrderTab to attach a new inspection (from a
// template) to the WO. Pure presentational — all state is owned by
// the parent so the WO can fire its `handleAddInspection` flow on
// confirm.  Extracted from WorkOrderTab.jsx (Feb 2026, iter174).
export function WOAddInspectionDialog({
  open, onOpenChange,
  form, setForm,
  templates = [], technicians = [],
  onConfirm,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Add Inspection to Work Order</DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          <div>
            <Label className="text-xs">Inspection Template *</Label>
            <Select
              value={form.template_id || "none"}
              onValueChange={(v) => setForm((f) => ({ ...f, template_id: v === "none" ? "" : v }))}
            >
              <SelectTrigger data-testid="select-wo-insp-template">
                <SelectValue placeholder="Select template" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="none">Select a Template</SelectItem>
                {templates.map((t) => (
                  <SelectItem key={t.id} value={t.id}>
                    {t.name}{t.scope_name ? ` (${t.scope_name})` : ""}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label className="text-xs">Inspector Name (optional)</Label>
            <Select
              value={form.inspector_name || "none"}
              onValueChange={(v) => setForm((f) => ({ ...f, inspector_name: v === "none" ? "" : v }))}
            >
              <SelectTrigger data-testid="input-wo-inspector">
                <SelectValue placeholder="e.g., Inspectah Deck" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="none">Select Inspector</SelectItem>
                {technicians.map((t) => (
                  <SelectItem key={t.id} value={t.name}>{t.name}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>
        <div className="flex justify-end gap-2 mt-4">
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={onConfirm} data-testid="btn-confirm-add-inspection">
            Add Inspection
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
